import styled from 'styled-components'

export const SectionWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.athensGray};
  border-radius: 4px;
  background: ${props => props.theme.colors.white};
  overflow: hidden;
  padding: 45px 40px 45px 40px;
  margin: 30px 0;
`
